import React, { Component } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import NativeSelect from "@material-ui/core/NativeSelect";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";

import logo from "../assets/Colored/Logo Only/GIQ Colored Logo.png";

export default class intake extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: "",
      studentFirstName: "",
      studentLastName: "",
      dob: "",
      gender: "female",
      school: "",
      grade: "",
      parentFirstName: "",
      parentLastName: "",
      email: "",
      zipcode: "",
      relationship: "",
      phoneNumber: "",
      thanks: "",
      printAd: false,
      onlineAd: false,
      referral: false,
      other: false,
      liability: false,
      privacy: false,
      errors: [],
      loading: false,
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleChecked = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const newAssessmentData = {
      location: this.state.location,
      studentFirstName: this.state.studentFirstName,
      studentLastName: this.state.studentLastName,
      dob: this.state.dob,
      gender: this.state.gender,
      school: this.state.school,
      grade: this.state.grade,
      parentFirstName: this.state.parentFirstName,
      parentLastName: this.state.parentLastName,
      email: this.state.email,
      zipcode: this.state.zipcode,
      relationship: this.state.relationship,
      phoneNumber: this.state.phoneNumber,
      thanks: this.state.thanks,
      printAd: this.state.printAd,
      onlineAd: this.state.onlineAd,
      referral: this.state.referral,
      other: this.state.other,
      liability: this.state.liability,
      privacy: this.state.privacy,
    };
    axios
      .post("/api/assessment", newAssessmentData)
      .then((response) => {
        this.setState({
          loading: false,
        });
        this.props.history.push("/success");
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data,
          loading: false,
        });
      });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.UI) {
      if (nextProps.UI.errors !== prevState.errors) {
        return { errors: nextProps.UI.errors };
      }
    } else return null;
  }

  render() {
    const { errors, loading } = this.state;
    return (
      <Container maxWidth="sm">
        <br />
        <br />
        <center>
          <img src={logo} width={100} alt="logo" />
          <br />
          <br />
          <Typography variant="h4" component="h2">
            Growing IQ Free Trial Form
          </Typography>
        </center>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl>
              <InputLabel htmlFor="location-native-helper">Location</InputLabel>
              <NativeSelect
                value={this.state.location}
                onChange={this.handleChange}
                inputProps={{
                  name: "location",
                  id: "location-native-helper",
                }}
              >
                <option aria-label="Select a Location" value="" />
                <option value={"Honolulu, HI"}>Honolulu, HI</option>
                <option value={"Sunnyvale, CA"}>Sunnyvale, CA</option>
                <option value={"Redwood City, CA"}>Redwood City, CA</option>
                <option value={"Hong Kong, HK"}>Hong Kong, HK</option>
              </NativeSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component="h2">
              Student Information
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="studentFirstName"
              label="First Name"
              name="studentFirstName"
              autoComplete="studentFirstName"
              helperText={errors.studentfirstName}
              error={errors.studentFirstName ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="studentLastName"
              label="Last Name"
              name="studentLastName"
              autoComplete="studentLastName"
              helperText={errors.studentLastName}
              error={errors.studentLastName ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="dob"
              label="Date of Birth"
              name="dob"
              autoComplete="dob"
              helperText={errors.dob}
              error={errors.dob ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <RadioGroup
              aria-label="gender"
              name="gender"
              value={this.state.gender}
              onChange={this.handleChange}
              required={true}
            >
              <FormControlLabel
                value={"female"}
                control={<Radio />}
                label="Female"
              />
              <FormControlLabel
                value={"male"}
                control={<Radio />}
                label="Male"
              />
              <FormControlLabel
                value={"decline"}
                control={<Radio />}
                label="Prefer not to answer"
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="school"
              label="School"
              name="school"
              autoComplete="school"
              helperText={errors.school}
              error={errors.school ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="grade"
              label="Grade"
              name="grade"
              autoComplete="grade"
              helperText={errors.grade}
              error={errors.grade ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Typography variant="h6" component="h2">
              Parent/Guardian
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="parentFirstName"
              label="First Name"
              name="parentFirstName"
              autoComplete="parentFirstName"
              helperText={errors.parentFirstName}
              error={errors.parentFirstName ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="parentLastName"
              label="Last Name"
              name="parentLastName"
              autoComplete="parentLastName"
              helperText={errors.parentLastName}
              error={errors.parentLastName ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              helperText={errors.email}
              error={errors.email ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="zipcode"
              label="Zip Code"
              name="zipcode"
              autoComplete="zipcode"
              helperText={errors.zipcode}
              error={errors.zipcode ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="relationship"
              label="Relationship to Student"
              name="relationship"
              autoComplete="relationship"
              helperText={errors.relationship}
              error={errors.relationship ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="phoneNumber"
              label="Phone Number"
              name="phoneNumber"
              autoComplete="phoneNumber"
              helperText="###-###-####"
              error={errors.phoneNumber ? true : false}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.printAd}
                    onChange={this.handleChecked}
                    name="printAd"
                  />
                }
                label="Print Ad"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.onlineAd}
                    onChange={this.handleChecked}
                    name="onlineAd"
                  />
                }
                label="Online Ad"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.referral}
                    onChange={this.handleChecked}
                    name="referral"
                  />
                }
                label="Referral"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.other}
                    onChange={this.handleChecked}
                    name="other"
                  />
                }
                label="Other"
              />
            </FormGroup>
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              fullWidth
              id="thanks"
              label="Who can we thank?"
              name="thanks"
              autoComplete="thanks"
              onChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required={true}
                  checked={this.state.liability}
                  onChange={this.handleChecked}
                  name="liability"
                />
              }
              label="I have read, understood, and accepted the liability release."
            />
            <FormHelperText>
              I hereby give consent to Growing IQ California Inc. for my child
              to participate in this program. I understand that my child will
              remain under the care, direction, and supervision of the facility
              while receiving instruction. I hereby release and discharge
              Growing IQ California Inc. the class facility, and their members
              from all actions, claims, demands, injury, or damages resulting
              from my child's participation in this activity.
            </FormHelperText>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required={true}
                  checked={this.state.privacy}
                  onChange={this.handleChecked}
                  name="privacy"
                />
              }
              label="I have read, understood, and accepted the privacy policy."
            />
            <FormHelperText>
              Growing IQ California Inc. understands that privacy is important
              to you and we are committed to respecting your privacy. Should you
              choose to provide us with any personal information, you can be
              assured that it will only be used by Growing IQ California Inc. to
              conduct official business. Personal information will never be
              disseminated to any unaffiliated third-party for solicitation
              without parent/guardian prior consent.
            </FormHelperText>
          </Grid>
          <Button
            color="primary"
            fullWidth={true}
            onClick={this.handleSubmit}
            disabled={
              loading ||
              !this.state.studentFirstName ||
              !this.state.studentLastName ||
              !this.state.dob ||
              !this.state.school ||
              !this.state.grade ||
              !this.state.parentFirstName ||
              !this.state.parentLastName ||
              !this.state.email ||
              !this.state.phoneNumber ||
              !this.state.liability ||
              !this.state.privacy ||
              !this.state.location
            }
          >
            Send
          </Button>
        </Grid>
      </Container>
    );
  }
}
